import { render, staticRenderFns } from "./SuperAdminIdent.vue?vue&type=template&id=5e0e8944&"
import script from "./SuperAdminIdent.vue?vue&type=script&lang=js&"
export * from "./SuperAdminIdent.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminIdent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports